<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>{{title}}</strong>
          </div>
          <div>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Phần mềm đồng bộ:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ $store.getters.getSyncSourceType(reportSync.syncSourceType) }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Đơn vị đồng bộ:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ reportSync.syncUnitName }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Ngày đồng bộ:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ reportSync.syncDate | formatTime }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Thời gian thực hiện:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ reportSync.elapsedTime }} ms</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Mẫu báo cáo:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ $store.getters.getReportSyncTypeName(reportSync.reportTypeId) }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Ngày báo cáo:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ getReportDate(reportSync) }} </label>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="reportSync.assetTypeGroupName">
                <b-form-group label="Loại tài sản:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ reportSync.assetTypeGroupName }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="reportSync.administrativeLevel">
                <b-form-group label="Cấp hành chính:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ $store.getters.getReportConstant(reportSync.administrativeLevel, 'administrativeLevels') }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="reportSync.regionName">
                <b-form-group label="Địa phương:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ reportSync.regionName }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="reportSync.handlingType || isShowHandlingType">
                <b-form-group label="Hình thức xử lý:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ $store.getters.getReportConstant(reportSync.handlingType, 'handlingTypes') }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Trạng thái:"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ $store.getters.getStatusName(reportSync.status ? 1 : 0) }}</label>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Mã quá trình đồng bộ (UUID):"
                              label-for="input-unit"
                              :label-cols="4"
                              :horizontal="true"
                              label-align="left">
                  <label class="col-form-label">{{ reportSync.syncProcessId }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <div class="form-group row" v-if="reportSync.errorMessage">
              <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Thông tin lỗi:</label>
              <div class="col-8 col-md-10">
                <json-viewer :data="reportSync.errorMessage"></json-viewer>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-md-2 text-left" style="padding-right: 3px">Dữ liệu gốc:</label>
              <div class="col-8 col-md-10">
                <json-viewer :data="reportSync.rawData"></json-viewer>
              </div>
            </div>
          </div>
          <!--<b-grid :searchForm="searchForm"
                  :gridOptions="gridOptions"
                  :items="reportSync.reportData"
                  gridName="Dữ liệu bào cáo được đồng bộ"
                  :showActions="false"
                  ref="assetSyncLogDataTable" v-if="logId">
              <template v-slot:top-row="{ columns }" v-if="hasGroup">
                  <td :colspan="columns">{{ reportSync.reportData[0].category }}</td>
              </template>
              <template v-slot:row-details="{ item }" v-if="hasGroup">
                  {{ item.nextCategory }}
              </template>
          </b-grid>-->
          <!--<div class="table-responsive" style="max-height: 600px" v-if="false && !reportSync.status && reportSync.reportData">
              <table class="table table-striped table-bordered table-hover table-light tableFixHead">
                  <thead>
                      <tr>
                          <th>STT</th>
                          <th v-for="col in tableInfo.columns" :title="col.title">
                              {{ col.label }}
                          </th>
                      </tr>
                  </thead>
                  <tbody>
                      <template v-if="tableInfo.groups && tableInfo.groups.length == 1">
                          <template v-for="(group, name, index) in groups">
                              <tr>
                                  <th>{{ (index + 1).romanize() }}.</th>
                                  <th :colspan="tableInfo.columns.length">{{ name == 'undefined' || name == 'null' ? 'Tổng số' : name }}</th>
                              </tr>
                              <tr v-for="(row, index) in group">
                                  <td>{{ index + 1 }}</td>
                                  <td v-for="col in tableInfo.columns">
                                      {{ row[col.key] | formatNumber }}
                                  </td>
                              </tr>
                          </template>
                      </template>
                      <template v-if="tableInfo.groups && tableInfo.groups.length == 2">
                          <template v-for="(group1, name1, index) in groups">
                              <tr>
                                  <th>{{ (index + 1).toAlphabet() }}.</th>
                                  <th :colspan="tableInfo.columns.length">{{ name1 == 'undefined' || name1 == 'null' ? 'Tổng số' : name1 }}</th>
                              </tr>
                              <template v-for="(group2, name2, index2) in group1">
                                  <tr>
                                      <th>{{ (index2 + 1).romanize() }}.</th>
                                      <th :colspan="tableInfo.columns.length">{{ name2 == 'undefined' || name2 == 'null' ? 'Tất cả' : name2 }}</th>
                                  </tr>
                                  <tr v-for="(row, index) in group2">
                                      <td>{{ index + 1 }}</td>
                                      <td v-for="col in tableInfo.columns">
                                          {{ row[col.key] | formatNumber }}
                                      </td>
                                  </tr>
                              </template>
                          </template>
                      </template>
                      <template v-if="tableInfo.groups == null || tableInfo.groups.length == 0">
                          <tr v-for="(row, index) in reportSync.reportData">
                              <td>{{ index + 1 }}</td>
                              <td v-for="col in tableInfo.columns">
                                  {{ row[col.key] | formatNumber }}
                              </td>
                          </tr>
                      </template>
                  </tbody>
              </table>
          </div>-->

          <div v-if="reportSync.status && reportSync.syncReportTargetId">
            <h2>Dữ liệu báo cáo</h2>
            <iframe :src="getReportUrl(reportSync)" style="width: 100%; height: 540px;"></iframe>
            <br />
            <br />
          </div>

          <div class="text-center">
            <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
            <!--<b-button type="button" variant="secondary" :to="{ path: getReportUrl()}" v-if="reportSync.status == 1">Xem báo cáo</b-button>-->
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mixins } from '@/shared/mixins'
  import { mapState } from 'vuex'

  export default {
    name: 'ListAssetSource',
    mixins: [mixins],
    data() {
      return {
        searchForm: {
          filter: null
        },
        gridOptions: {
          fields: [

          ],
          sortBy: 'isValid',
        },
        reportSync: {

        },
        tableInfo: {
          columns: [],
          groups: []
        },
        detailsShowing: false,
        isShowHandlingType: false,
        isShowInfrastructureAssetType: false
      }
    },
    computed: {
      logId() {
        return this.$route.params.logId;
      },
      groups() {
        var vm = this;
        var result = vm.reportSync.reportData || [];
        if (vm.tableInfo.groups) {
          for (var i = 0; i < vm.tableInfo.groups.length; i++) {
            var groupField = vm.tableInfo.groups[i];
            if (i == 0) {
              result = vm._.groupBy(result, groupField);
            } else {
              for (var p in result) {
                result[p] = vm._.groupBy(result[p], groupField);
              }
            }
          }
        }
        return result;
      },
      ...mapState({
        tableComments: (state) => state.common.tableComments
      })
    },
    created() {
      this.loadLogDetail();
      if (this.$route.meta.title) {
        this.title = this.$route.meta.title;
      }
    },
    methods: {
      loadLogDetail() {
        var vm = this;
        var getters = vm.$store.getters;

        return this.$services.get(`logging/report-sync-logs/${this.logId}`).done(data => {
          var rawData;

          //try {
          //rawData = JSON.parse(data.rawData);
          //data.rawDataJSON = JSON.parse(JSON.stringify(rawData));

          //var reportData = rawData.reportData || rawData.REPORT_DATA || [];

          //var reportSyncType = getters.getReportSyncType(data.reportTypeId);

          //if (reportData.length > 0) {

          //    // Mapping enum ID to description
          //    if (reportSyncType.mapping) {
          //        reportData.forEach((row) => {

          //            var cols = []
          //            for (var prop in row) {
          //                cols.push(prop);
          //            }

          //            for (var i = 0; i < cols.length; i++) {
          //                var columnName = _.snakeCase(cols[i]).toUpperCase();
          //                if (cols[i] != columnName) {
          //                    row[columnName] = row[cols[i]];
          //                    delete row[cols[i]];
          //                }
          //            }

          //            reportSyncType.mapping.forEach((mapping) => {
          //                row[mapping.key] = getters.getReportConstant(row[mapping.key], mapping.value);
          //            });
          //        });
          //    }

          //    if (reportSyncType.code == 'BCCP_TSC/BCCP_01_TSC' || reportSyncType.code == 'BCCP_TSC/BCCP_04_TSC' || reportSyncType.code == 'BCCP_TSC/BCCP_10_TSC') {
          //        for (var i = 0; i < reportData.length; i++) {
          //            var row = reportData[i];

          //            var assetGroup;
          //            var assetType;

          //            if (row.SUMMARY_INFO != undefined) {
          //                if (row.SUMMARY_INFO == 1) {
          //                    assetGroup = 'Tổng cộng (A+B)';
          //                } else if (row.SUMMARY_INFO == 2) {
          //                    assetGroup = 'Tài sản cố định tại các cơ quan, tổ chức, đơn vị, ban quản lý dự án';
          //                    assetType = 'Tổng số';
          //                } else if (row.SUMMARY_INFO == 3) {
          //                    assetGroup = 'Tài sản kết cấu hạ tầng';
          //                    assetType = 'Tổng số';
          //                } else if (row.SUMMARY_INFO == 4) {
          //                    assetGroup = 'Tài sản được xác lập quyền sở hữu toàn dân';
          //                    assetType = 'Tổng số';
          //                }

          //                if (row.ADMINISTRATIVE_LEVEL == null) {
          //                    row.ADMINISTRATIVE_LEVEL = 'Tất cả';
          //                }
          //            } else {
          //                assetGroup = row.NATIONAL_PUBLIC_ASSET_TYPE ? 'Tài sản được xác lập quyền sở hữu toàn dân' : row.ORGANIZATION_ASSET_TYPE ? 'Tài sản cố định tại các cơ quan, tổ chức, đơn vị, ban quản lý dự án' : row.INFRASTRUCTURE_ASSET_TYPE ? 'Tài sản kết cấu hạ tầng' : 'Tổng số';
          //                assetType = row.NATIONAL_PUBLIC_ASSET_TYPE || row.ORGANIZATION_ASSET_TYPE || row.INFRASTRUCTURE_ASSET_TYPE || '';
          //            }

          //            row = Object.assign({ ASSET_TYPE: assetType, ASSET_GROUP: assetGroup }, row);

          //            delete row.NATIONAL_PUBLIC_ASSET_TYPE;
          //            delete row.ORGANIZATION_ASSET_TYPE;
          //            delete row.INFRASTRUCTURE_ASSET_TYPE;

          //            reportData[i] = row;
          //        }
          //    }

          //    for (var prop in reportData[0]) {
          //        if ((!reportSyncType.excluding || reportSyncType.excluding.indexOf(prop) == -1) && (!reportSyncType.grouping || reportSyncType.grouping.indexOf(prop) == -1)) {
          //            vm.tableInfo.columns.push({ key: prop, label: vm.getPropName(prop, reportSyncType.table), title: prop });
          //        }
          //    }

          //    vm.tableInfo.groups = reportSyncType.grouping;

          //    data.reportData = reportData;
          //}

          //} catch (ex) {
          //    console.log(ex);
          //}
          vm.reportSync = data;
          if (vm.reportSync.reportTypeId == 26 && !vm.reportSync.handlingType) {
            vm.isShowHandlingType = true;
          }
          if (vm.reportSync.reportTypeId == 27 && !vm.reportSync.infrastructureAssetType) {
            vm.isShowInfrastructureAssetType = true;
          }
          //vm.$refs.assetSyncLogDataTable.refresh();
        });
      },
      getPropName(columnName, tableName) {
        if (columnName) {
          columnName = _.snakeCase(columnName).toUpperCase();
        }

        if (columnName && columnName.indexOf('ASSET_TYPE') != -1) {
          return 'Loại tài sản';
        }

        var col = this.tableComments.find(x => x.columnName == columnName && x.tableName == tableName);

        if (col) {
          if (!col.comments) return columnName;

          var index = col.comments.indexOf('.');
          return index == - 1 ? col.comments : col.comments.substr(0, index);
        } else {
          return columnName;
        }
      },
      getReportDate(report) {

        if (report.reportTypeId) {

          var reportType = this.$store.getters.getReportSyncType(report.reportTypeId);
          var format = defaultDisplayFormatDate;
          switch (reportType.periodType) {
            case 1: return formatDate(report.reportEndDate, format);
            case 2: return `${formatDate(report.reportStartDate, format)} - ${formatDate(report.reportEndDate, format)}`;
            case 3: return report.reportYear ? `31/12/${report.reportYear}` : '';
          }
        }
      },
      getReportUrl(data) {
        var url = this.$store.getters.getGroupReportTypeCode(data.reportTypeGroup) || '404';
        var jsonParameter = {
          reportId: data.syncReportTargetId,
          userId: this.$store.state.identity.userId
        };
        var reportSyncType = this.$store.getters.getReportSyncType(data.reportTypeId);

        switch (reportSyncType.periodType) {
          case 1: jsonParameter.reportDate = formatDate(data.reportEndDate, 'YYYY-MM-DD'); break; // báo cáo theo ngày
          case 2: // báo cáo theo khoảng ngày
            {
              jsonParameter.reportStartDate = formatDate(data.reportStartDate, 'YYYY-MM-DD');
              jsonParameter.reportEndDate = formatDate(data.reportEndDate, 'YYYY-MM-DD');
            } break;
          case 3: jsonParameter.reportYear = data.reportYear; break; // báo cáo theo năm
        }

        //if (reportSyncType.unitTree) {
        //    queryString += `&unitId=${data.syncUnitId}`;
        //}

        if (reportSyncType.assetTypeGroupId) {
          jsonParameter.assetTypeGroupId = data.assetTypeGroupId ? [data.assetTypeGroupId] : [];
          //if (reportSyncType.assetTypeLevel) {
          //    if (reportSyncType.assetTypeGroupId == 3) {
          //        queryString += `&assetTypeLevel=${data.assetTypeLevel || ''}`;
          //    }
          //    else {
          //        queryString += `&assetTypeLevel=5`;
          //    }
          //}
        }

        if (reportSyncType.handlingType) {
          jsonParameter.handlingType = data.handlingType;
        }

        if (reportSyncType.administrativeLevel) {
          jsonParameter.administrativeLevel = data.administrativeLevel;
          jsonParameter.regionId = data.regionId;
        }

        if (reportSyncType.assetSource) {
          jsonParameter.assetSourceId = data.assetSourceId ? [data.assetSourceId] : [];
        }

        if (reportSyncType.assetTypeLevel) {
          jsonParameter.assetTypeLevel = data.assetTypeLevel || 5;
        }

        if (reportSyncType.unitLevel) {
          jsonParameter.unitLevel = data.unitLevel || 5;
        }

        if (reportSyncType.decisionNumber) {
          jsonParameter.decisionNumber = data.decisionNumber;
        }
        return `${this.$services.REPORT_END_POINT}${reportSyncType.code}.aspx?parameter=${encodeURI(JSON.stringify(jsonParameter))}`;
      },
    },
    watch: {
      logId() {
        this.loadLogDetail();
      }
    }
  }
</script>
<style scoped>
  .tableFixHead {
    overflow-y: auto;
  }

    .tableFixHead thead th {
      position: sticky;
      top: 0;
    }

  /* Just common table stuff. Really. */
  table {
    border-collapse: collapse;
    width: 100%;
  }

  th, td {
    padding: 8px 16px;
  }

  th {
    background: #eee;
  }
</style>
